import React, { useState, useEffect, useRef } from "react";
import '../App.css';
import { useSelector } from "react-redux";

import Navbar from "../components/Navbar";
import PatientData from "../components/PatientData";
import ProgressBar from "../components/ProgressBar";
import { useSearchParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { IoClose } from 'react-icons/io5';
import { IoCloseCircle } from "react-icons/io5";
import { ToastContainer, toast } from 'react-toastify';
import { useAppDispatch } from "../redux/store";
import { requestStudiesList, requestReport, updateDashboardStudy } from "../redux/OsteroCheckSlice";
import { IoCheckmarkCircle } from "react-icons/io5";
import Notavailable from '../assets/no-image.png'
import { MdOutlineQuestionMark } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { FaShare, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { surgical_data } from "../constant";
import Measurementtable from "../components/Measurementtable";
import Dicom from '../components/Dicom'

const Reports = () => {
  // const [searchParams, setSearchParams] = useSearchParams();
  const [matchingDatavalues, setMatchingDatavalues] = useState(null);
  const [extractedValue, setExtractedValue] = useState(null);
  const appDispatch = useAppDispatch();
  const [history, sethistory] = useState('')
  const [selected, setSelected] = useState("fullReport");
  const [comments, setComments] = useState('');
  const [selectedStudyId, setSelectedStudyId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [localPatientData, setLocalPatientData] = useState(null);
  const patientData = useSelector(
    (state) => state.OsteroCheck.patientData
  );
  const jsonData = patientData.data?.json;
  const reasonData = useSelector((state) => state.reportBuilder.reasonData);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const mod_study = useSelector((state) => state.OsteroCheck.patientList)
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const shouldRender = location.pathname === '/reports' && !location.search;
  const measurementtable = [184648, 3985587, 4219659, 3890502, 4119190, 4224663, 4219439];
  const excludedOrderIds = [184648, 3985587, 4219659, 3890502, 4119190, 4224663, 4219439];





  const toggleDropdown = () => setIsOpen(!isOpen);

  console.log("jsondata", patientData)
  const pathologiesData = patientData?.data?.json?.pathologies?.[0];
  console.log("pathologiesdata", pathologiesData);


  const truePathologies = pathologiesData
    ? Object.entries(pathologiesData)
      .filter(([key, value]) => value === true)
      .map(([key, value]) => key)
    : [];


  const isCompleted = location.pathname === '/reports' && location.search === '?type=completed';



  console.log("patientdata", mod_study)






  const studies = useSelector(
    (state) => state.OsteroCheck.patientList
  );


  useEffect(() => {
    if (patientData.data) {
      setLocalPatientData(patientData.data);
    }
  }, [patientData]);

  useEffect(() => {
    if (jsonData?.url) {
      const parts = jsonData.url.split('/');
      const lastPart = parts.pop()?.split('.')[0];
      sethistory(lastPart || '');
    } else {
      console.log("URL is undefined");
    }

    if (jsonData?.tabledata) {
      setTableData(jsonData.tabledata);
    }
    if (jsonData?.tabledata1) {
      setTableData1(jsonData.tabledata1);
    }
    if (jsonData?.tabledata2) {
      setTableData2(jsonData.tabledata2);
    }
  }, [jsonData]);

  const handleCheckClick = async (event) => {
    try {
      const button = event.currentTarget;
      const fillElement = button.querySelector('.fill-animation');
      fillElement.classList.add('active');

      const emergencyValue = patientData.data.action.emergency || false;

      const result = await appDispatch(updateDashboardStudy({
        study_id: patientData.data.order_id,
        action: { case: true, feedback: false, emergency: emergencyValue },
        comment: ''
      })).unwrap();

      setLocalPatientData(prevData => ({
        ...prevData,
        action: { ...prevData.action, case: true, feedback: false }
      }));

      toast.success('Case accepted successfully!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      appDispatch(requestStudiesList());

      return { success: true, emergencyValue, result };
    } catch (error) {
      console.error('Failed to update study:', error);

      toast.error('Failed to accept case. Please try again.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return { success: false, error };
    }
  };
  const handleSendFeedback = () => {
    setSelectedStudyId(patientData.data.order_id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedStudyId(null);
    setComments('');
  };

  const handleSubmitComment = async () => {
    if (selectedStudyId && comments.trim()) {
      setIsSubmitting(true);
      setError(null);
      try {
        const emergencyValue = patientData.data.action.emergency || false;
        await appDispatch(updateDashboardStudy({
          study_id: selectedStudyId,
          action: { case: false, feedback: true, emergency: emergencyValue },
          comment: comments
        })).unwrap();
        closeModal();
        setLocalPatientData(prevData => ({
          ...prevData,
          action: { ...prevData.action, case: false, feedback: true }
        }));
        appDispatch(requestStudiesList())
      } catch (err) {
        setError("Failed to submit comment. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    }
  };


  const highlightPathologies = (sentence, pathologies) => {
    let highlightedSentence = sentence;
    pathologies.forEach(pathology => {
      const regex = new RegExp(`\\b${pathology}\\b`, 'gi');
      highlightedSentence = highlightedSentence.replace(regex, `<strong>${pathology}</strong>`);
    });
    return highlightedSentence;
  };


  const transformLabel = (label) => {
    switch (label) {
      case "ChestR":
        return "XRAY Radiograph Chest - PA";
      case "SXR":
        return "XRAY Radiograph Spine";
      case "MRI spine":
        return "Contrast MRI Spine";
      case "CT brain":
        return "CT Brain Plain";
      case "KXR":
        return "XRAY Radiograph knee";
      case "mribrain":
        return "MRI Brain";
      case "lifesaver":
        return "Life Saver";
      case "Mmrils":
        return "Measure MRI Lumbosacral Spine";
      case "Mmrics":
        return "Measure MRI Cervical Spine";
      case "Mxraycsm":
        return "Measure XRay Cervical Spine";
      case "Mxraydsm":
        return "Measure XRay Dorsal Spine";
      case "Mxraylsm":
        return "Measure XRay Lumbar Spine";
      case "Mcta":
        return "Measure CT Abdomen";
      default:
        return label;
    }
  }


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const shareViaGmail = () => {
    const subject = 'Check this out!';
    const body = `I thought you might be interested in this:`;
    // window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const shareViaWhatsApp = () => {
    const text = `Check this out:`;
    // window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const parseJsonUrl = (jsonString) => {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.error("Error parsing JSON url string:", error);
      return [];
    }
  };


  const getExtractedValue = (url) => {
    if (!url) return null;
    const splitUrl = url.split('/');
    const filename = splitUrl[splitUrl.length - 1];
    const keyImagePart = filename.split('_')[0];
    return keyImagePart;
  };

  useEffect(() => {
    if (jsonData?.url) {
      const extracted = getExtractedValue(jsonData.url);
      setExtractedValue(extracted);
      console.log("Extracted value:", extracted);

      if (extracted) {
        const matchingItem = surgical_data.find(item => item.imagename.toString() === extracted);
        console.log("Matching data:", matchingItem);
        setMatchingDatavalues(matchingItem);

        if (!matchingItem) {
          console.log("No matching data found. Available imagenames:", surgical_data.map(item => item.imagename));
        }
      }
    }
  }, [jsonData]);


  console.log("patientDatavalues", patientData.data.json.url)

  return (
    <div className="flex flex-col h-screen w-screen bg-[#f5f6fa]">
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={handleSubmitComment}
        isSubmitting={isSubmitting}
        error={error}
        comments={comments}
        setComments={setComments}
      />
      <ToastContainer />
      <div className="bg-white border border-solid rounded-md">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <Dicom />
        <div className="flex-1 p-4 overflow-y-auto">
          {patientData.loading ? (
            <div className="bg-white pt-4 grid gap-x-6 h-full justify-center items-center shadow-md rounded rounded-2xl p-8 bg-clean-white border box-border shadow-[4px_4px_4px_rgba(0,0,0,0.2)] border-gray-300">
              <div className="text-logo-blue inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                  Loading...
                </span>
              </div>
            </div>
          ) : (
            <div className='grid h-full grid-cols-4 gap-x-3 sm:flex sm:flex-col'>
              <div className="flex flex-col gap-4 overflow-y-auto max-h-[calc(100vh-4rem)]">
                {extractedValue === '3594825' && (
                  <div className="bg-white rounded-2xl p-6 border-2 border-[#ff2627]">
                    <div className="mb-4">
                      <label className="font-semibold text-[#4359A5]">Life Saver Pathology:</label>
                      <p className="mt-2 text-sm font-normal text-black">
                        Bowel perforation
                      </p>
                    </div>
                    <div>
                      <label className="font-semibold text-[#4359A5]">Life Saver Reason:</label>
                      <p className="mt-2 text-sm font-normal text-black">
                        Creates an opening in the intestinal wall, allowing the contents of the bowel to spill into the abdominal cavity, leading to infection, peritonitis, and potentially life-threatening complications if not treated promptly.
                      </p>
                    </div>
                  </div>
                )}
                {type === 'completed' && (
                  <div className="p-6 bg-white rounded-2xl">
                    <div className="mb-4">
                      <label className="font-semibold text-[#4359A5]">Surgical Pathology:</label>
                      {reasonData && reasonData.surgical ? (
                        <p className="mt-2 text-sm font-normal text-black">
                          {reasonData.surgical_pathology.join(", ")}
                        </p>
                      ) : (
                        <p className="mt-2 text-sm text-gray-500 tracking-[1px]">NA</p>
                      )}
                    </div>
                    <div>
                      <label className="font-semibold text-[#4359A5]">Reason:</label>
                      {reasonData && reasonData.Reason && reasonData.Reason.length > 0 ? (
                        reasonData.Reason.length === 2 ? (
                          <ul className="mt-2 text-sm list-disc">
                            {reasonData.Reason.map((reason, index) => (
                              <li key={index} className="mt-1">
                                {reason}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="mt-2 text-sm">{reasonData.Reason[0]}</p>
                        )
                      ) : (
                        <p className="mt-2 text-sm text-gray-500 tracking-[1px]">NA</p>
                      )}
                    </div>
                  </div>
                )}


                {shouldRender && (
                  <div className="p-6 bg-white rounded-2xl">
                    <div className="mb-4">
                      <label className="font-semibold text-[#4359A5]">Surgical Pathology:</label>
                      {matchingDatavalues ? (
                        <p className="mt-2 text-sm font-normal text-black">
                          {matchingDatavalues.surgical_pathology.join(", ")}
                        </p>
                      ) : (
                        <p className="mt-2 text-sm text-gray-500 tracking-[1px]">NA</p>
                      )}
                    </div>
                    <div>
                      <label className="font-semibold text-[#4359A5]">Reason:</label>
                      {matchingDatavalues ? (
                        <ul className="pl-5 mt-2 text-sm list-disc">
                          {matchingDatavalues.surgical_reason.map((reason, index) => (
                            <li key={index} className="mt-1">
                              {reason}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="mt-2 text-sm text-gray-500 tracking-[1px]">NA</p>
                      )}
                    </div>
                  </div>
                )}



                <div>
                  {jsonData?.url ? (
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                      {parseJsonUrl(jsonData.url).map((imageUrl, index) => (
                        <div key={index} className="pb-8 bg-transparent Key-image rounded-xl">
                          <img
                            src={imageUrl}
                            alt={`Image ${index + 1}`}
                            className="h-auto max-w-full rounded-xl fade-in"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = './img/no-image.png';
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <img
                      src={Notavailable}
                      alt="Fallback Image"
                      className="max-w-full rounded-xl bg-[#f2f2f2] p-4"
                    />
                  )}
                </div>
              </div>

              <div className="col-span-3 shadow-md rounded-2xl p-8 pr-2 bg-clean-white border box-border shadow-[4px_4px_4px_rgba(0,0,0,0.2)] bg-white border-gray-300 overflow-y-auto sm:p-5">

                <div className="flex items-center text-dark-blue-60">
                  <div className="flex items-center gap-2">
                    <img
                      className="max-w-full max-h-full overflow-hidden"
                      alt=""
                      src="/img/back.svg"
                    />
                    <div
                      className="inline-block font-semibold cursor-pointer"
                      onClick={() => {
                        if (type === "completed") navigate("/list");
                        else navigate("/list");
                      }}
                    >
                      Back
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between ">
                  <div className="relative w-[60%] mt-4 rounded-md border h-10 p-1 bg-gray-200">

                    <div className="relative flex items-center w-full h-full">
                      <div
                        onClick={() => setSelected("fullReport")}
                        className="flex justify-center w-full text-gray-400 cursor-pointer"
                      >
                        <button>Full Report</button>
                      </div>
                      <div
                        onClick={() => setSelected("findings")}
                        className="flex justify-center w-full text-gray-400 cursor-pointer"
                      >
                        <button>Findings</button>
                      </div>

                    </div>
                    <span
                      className={`
                      bg-white shadow text-sm flex items-center justify-center w-1/2 rounded h-[1.88rem] 
                      transition-all duration-150 ease-linear top-[4px] absolute
                      ${selected === "findings"
                          ? 'left-1/2 -ml-1 text-[#4359A5] font-semibold'
                          : 'left-1 text-[#4359A5] font-semibold'
                        }
                    `}
                    >
                      {selected === "findings" ? 'Findings' : 'Full Report'}
                    </span>

                  </div>
                </div>
                {selected === "fullReport" && (
                  <>
                    <div className="flex-grow text-center mt-8 text-[#4359A5] font-bold text-2xl">
                      <label className="font-semibold tracking-[0.5px]">
                        {/* {isCompleted
                          ? transformLabel(patientData?.data?.mod_study)
                          : transformLabel(mod_study?.data?.data[0]?.mod_study)} */}
                        {patientData?.data?.json?.header}

                      </label>
                    </div>
                    {jsonData.history && jsonData.history.trim() !== "" && (
                      <div className="flex items-center mt-8 history">
                        <label className="font-bold text-left text-xl text-[#4359A5]">History:&nbsp;</label>
                        <p className="mt-0 text-base">{jsonData.history}</p>
                      </div>
                    )}
                    {jsonData.tableheader && (() => {
                      const url = patientData.data.json.url;

                      // Extract the first ID from the URL
                      const firstExtractedId = url.match(/\/(\d+)_keyimage_\d\.png$/)?.[1];

                      // Extract the second part for comparison (if applicable, adapt the regex based on your use case)
                      const secondExtractedId = url.match(/\/(\d+)_keyimage_\d\.png$/)?.[1];

                      // Compare the two extracted values
                      if (firstExtractedId === secondExtractedId) {
                        return false; // Don't render the section if values are the same
                      }

                      return true; // Render the section if values are different
                    })() && (
                        <div className="flex items-center mt-8 history">
                          <label className="font-bold text-left text-lg text-[#4359A5]">
                            {jsonData.tableheader}
                          </label>
                          {/* Uncomment if needed */}
                          {/* <p className="mt-0 text-base">{jsonData.tableheader}</p> */}
                        </div>
                      )}






                    <div className="py-4">
                      <>
                        {console.log("valuesinorderid", patientData.data.order_id)}

                        {jsonData.observations.length > 0 && (
                          <h3 className="text-xl font-bold text-[#4359A5]">Observation</h3>
                        )}
                        {jsonData.observations.map((item, index) => {
                          const [heading, observations] = Object.entries(item)[0];
                          return (
                            <div key={index} className="mt-4 mb-2">
                              {heading.toLowerCase() !== 'untitled' && (
                                <p className="pb-1 pl-2 font-semibold text-black text-md">{heading}</p>
                              )}
                              <ul className="pl-8 text-gray-800 list-disc">
                                {observations.map((observation, obsIndex) => (
                                  <li
                                    key={obsIndex}
                                    className="text-sm leading-6"
                                    dangerouslySetInnerHTML={{ __html: observation }}
                                  ></li>
                                ))}
                              </ul>
                            </div>
                          );
                        })}
                      </>
                    </div>

                    {(() => {
                      const url = patientData.data.json.url;

                      // Extract the first ID from the URL
                      const firstExtractedId = url.match(/\/(\d+)_keyimage_\d\.png$/)?.[1];

                      // Extract another ID or compare directly with firstExtractedId
                      const secondExtractedId = url.match(/\/(\d+)_keyimage_\d\.png$/)?.[1]; // Modify regex if needed

                      // Check if extracted IDs match
                      if (firstExtractedId === secondExtractedId && jsonData.tableheader) {
                        return (
                          <div className="flex items-center mb-4 history">
                            <label className="font-bold text-left text-lg text-[#4359A5]">
                              {jsonData.tableheader}
                            </label>
                            {/* Uncomment if needed */}
                            {/* <p className="mt-0 text-base">{jsonData.tableheader}</p> */}
                          </div>
                        );
                      }

                      return null;
                    })()}






                    {tableData.length > 0 && (
                      <div className="pb-10 overflow-x-auto">
                        <table className="min-w-[300px] w-auto max-w-[500px] border-collapse border border-gray-300 mt-2">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="p-2 text-sm font-semibold border border-gray-300">Level</th>
                              <th className="p-2 text-sm font-semibold border border-gray-300">AP diameter(mm)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tableData.map((row, index) => (
                              <tr key={index}>
                                <td className="p-2 text-sm text-center border border-gray-300">{row.Level}</td>
                                <td className="p-2 text-sm text-center border border-gray-300">{row["AP diameter(mm)"]}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {tableData1.length > 0 && (
                      <div className="pb-10 overflow-x-auto">
                        <table className="min-w-[300px] w-auto max-w-[500px] border-collapse border border-gray-300 mt-2">
                          <thead>
                            <tr className="bg-gray-100">
                              {Object.keys(tableData1[0]).map((header, index) => (
                                <th key={index} className="p-2 text-sm font-semibold text-left border border-gray-300">
                                  {header}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {tableData1.map((row, index) => (
                              <tr key={index}>
                                {Object.keys(row).map((key, cellIndex) => (
                                  <td key={cellIndex} className="p-2 text-sm text-left border border-gray-300">
                                    {row[key]}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <Measurementtable data={tableData2} />

                    <div className="">
                      <>
                        {jsonData.observations.length > 0 && (
                          <p className="font-bold pb-1 text-xl text-[#4359A5]">Impression</p>
                        )}
                        <ul className="pl-4 pl-8 text-gray-700 list-disc">
                          {jsonData?.impression?.map((data, index) => (
                            <li key={index} className="text-sm leading-6" dangerouslySetInnerHTML={{ __html: data }}></li>
                          ))}
                        </ul>
                      </>
                    </div>




                    {patientData.data.order_id === '819584' && (
                      <div>
                        <p className="font-bold pb-1 text-xl text-[#4359A5] mt-5">Advice</p>
                        <p className="text-sm leading-6 ">Clinical correlation</p>
                      </div>
                    )}

                  </>
                )}
                {selected === "findings" && (
                  <div className="mt-[3rem]">
                    <p className="font-bold pb-1 text-xl text-[#4359A5]">Findings</p>
                    <ul className="pl-4 font-bold text-gray-700 list-disc">
                      <div className="grid grid-cols-3 gap-4 pt-4 sm:flex sm:flex-col">
                        {jsonData?.pathologies &&
                          Array.isArray(jsonData.pathologies) &&
                          jsonData.pathologies.length > 0 &&
                          Object.entries(jsonData.pathologies[0])
                            .filter(([key, value]) => value === true)
                            .map(([key, value], index) => (
                              <div
                                key={index}
                                className="flex items-center gap-2 text-xl">
                                <IoCheckmarkCircle className="text-[#0a8807]" />
                                <span className="text-base font-bold">{key}</span>
                              </div>
                            ))}
                        {jsonData?.pathologies &&
                          Array.isArray(jsonData.pathologies) &&
                          jsonData.pathologies.length > 0 &&
                          Object.entries(jsonData.pathologies[0])
                            .filter(([key, value]) => value === false)
                            .map(([key, value], index) => (
                              <div
                                key={index}
                                className="flex items-center gap-2 text-xl">
                                <IoCloseCircle className=" text-[#df1818]" />
                                <span className="text-base font-normal">{key}</span>
                              </div>
                            ))}
                      </div>
                    </ul>
                  </div>
                )}


              </div>
              <div className="absolute flex gap-2 right-4">
                <div className="relative inline-block group">
                  <button
                    className={`p-2 rounded-tr-none rounded-bl-lg rounded-br-none ${localPatientData?.action.feedback
                      ? 'bg-red-500 text-white'
                      : localPatientData?.action.case
                        ? 'bg-gray-400 text-white cursor-not-allowed'
                        : 'bg-gray-400 text-white hover:bg-red-500'
                      }`}
                    onClick={handleSendFeedback}
                    disabled={localPatientData?.action.case || localPatientData?.action.feedback}
                  >
                    <span className="relative z-10 flex items-center justify-center space-x-2">
                      <MdOutlineQuestionMark size={22} />
                      <span> {localPatientData?.action.feedback ? 'Feedback Sent' : 'Send Feedback'}</span>
                    </span>
                  </button>
                  <p className="absolute z-50 px-2 py-1 text-xs text-center text-white transition-opacity duration-300 transform -translate-x-1/2 -translate-y-2 bg-black rounded-lg shadow-lg opacity-0 pointer-events-none w-28 bottom-full left-1/2 group-hover:opacity-100">
                    {localPatientData?.action.feedback ? 'Feedback Sent' : 'Send Feedback'}
                  </p>
                </div>
              </div>
            </div>
          )}
          <div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Modal = ({ isOpen, onClose, onSubmit, isSubmitting, error, comments, setComments }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-1/3 p-6 bg-white rounded-lg">
        <button
          onClick={onClose}
          className="absolute text-gray-500 top-3 right-3 hover:text-gray-700"
          aria-label="Close modal"
        >
          <IoClose size={24} />
        </button>
        <h2 className="mb-4 text-xl font-semibold">Send Feedback</h2>
        <textarea
          className="w-full p-2 text-sm text-black border rounded text-opacity-70"
          rows="4"
          placeholder="Enter your feedback here..."
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        ></textarea>
        {error && <p className="mt-2 text-red-500">{error}</p>}
        <div className='flex justify-end gap-3'>
          <button onClick={onClose} className="mt-4 bg-white text-red-500 px-4 py-2 font-normal border-[1.5px] border-solid border-red-500 rounded hover:bg-red-500 hover:text-white" disabled={isSubmitting}>
            Close
          </button>
          <button onClick={onSubmit} className="mt-4 bg-white text-[#1777ff] font-normal px-4 py-2 border-[1.5px] border-solid border-[#1777ff] rounded hover:bg-[#1777ff] hover:text-white" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};


export default Reports;